export default {"src":"/_next/static/image/public/images/ic_payment_failed.959a4cf6f7da3eb2275e7ddb72beda9d.svg","height":153,"width":189};